import { t } from 'i18next';

export const FaqQuestions = [
  {
    question: t('comoFacoAlterarTemperatura'),
    answer: {
      text: '',
      list: [
        t('respostaComoFacoAlterarTemperatura1'),
        t('respostaComoFacoAlterarTemperatura2'),
        t('respostaComoFacoAlterarTemperatura3'),
      ],
    },
    dataTestId: 'controle_inteligente-tag-alterar_temperatura-faq',
  },
  {
    question: t('comoEncontrarMinhaMaquina'),
    answer: {
      text: t('respostaComoEncontrarMinhaMaquina1'),
      list: [
        t('respostaComoEncontrarMinhaMaquina2'),
        t('respostaComoEncontrarMinhaMaquina3'),
      ],
    },
    dataTestId: 'controle_inteligente-tag-encontrar_maquina-faq',
  },
  {
    question: t('oQueFazerNaoEncontrarMaquina'),
    answer: {
      text: '',
      list: [
        t('respostaOQueFazerNaoEncontrarMaquina1'),
        t('respostaOQueFazerNaoEncontrarMaquina2'),
        t('respostaOQueFazerNaoEncontrarMaquina3'),
      ],
    },
    dataTestId: 'controle_inteligente-tag-nao_encontro_a_maquina-faq',
  },
  {
    question: t('oQueFazerMaquinaOffline'),
    answer: {
      text: t('respostaOQueFazerMaquinaOffline1'),
      list: [
        t('respostaOQueFazerMaquinaOffline2'),
        t('respostaOQueFazerMaquinaOffline3'),
        t('respostaOQueFazerMaquinaOffline4'),
        t('respostaOQueFazerMaquinaOffline5'),
        t('respostaOQueFazerMaquinaOffline6'),
      ],
    },
    dataTestId: 'controle_inteligente-tag-maquina_offline-faq',
  },
  {
    question: t('oQueFazerMaquinaEstadoCritico'),
    answer: {
      text: '',
      list: [
        t('respostaOQueFazerMaquinaEstadoCritico2'),
        t('respostaOQueFazerMaquinaEstadoCritico3'),
      ],
    },
    dataTestId: 'controle_inteligente-tag-maquina_estado_critico-faq',
  },
  {
    question: t('oQueModoEconomia'),
    answer: {
      text: t('respostaOQueModoEconomia1'),
      list: [],
    },
    dataTestId: 'controle_inteligente-tag-o_que_e_modo_economia-faq',
  },
  {
    question: t('oQueModoLivre'),
    answer: {
      text: '',
      list: [
        t('respostaOQueModoLivre1'),
        t('respostaOQueModoLivre2'),
      ],
    },
    dataTestId: 'controle_inteligente-tag-o_que_e_modo_livre-faq',
  },
  {
    question: t('oQueMaquinaForaHorarioFuncionamento'),
    answer: {
      text: t('respostaOQueMaquinaForaHorarioFuncionamento1'),
      list: [],
    },
    dataTestId: 'controle_inteligente-tag-o_que_e_maquina_fora_do_horario-faq',
  },
];
